@if (options.length) {
  <div class="select-container">
    <div ngbDropdown class="dropdown" container="body" (openChange)="getDropdownState($event)">
      <button
        type="button"
        class="input-wrapper input"
        [class]="{'opened': dropdownOpen}"
        ngbDropdownToggle
      >
        @if (selectedOption) {
          <div class="text" [title]="selectedOption.label">{{ selectedOption.label }}</div>
        }
        <span class="icon ic-select-20"></span>
      </button>
      <div ngbDropdownMenu class="dropdown-menu">
        @if (options.length) {
          @for (option of sortedOptions; track $index) {
            <button
              ngbDropdownItem
              type="button"
              class="dropdown-item"
              (click)="selectOption(option)"
            >
              <div class="dropdown-button">
                <span
                  [class]="{'bold-label': option.label === selectedOption?.label && option.value === selectedOption?.value }">
                  {{ option.label }}
                </span>

                <span
                  class="icon"
                  [class]="{'ic-checkmark-circle-16': option.label === selectedOption?.label && option.value === selectedOption?.value }"
                ></span>
              </div>
            </button>
          }
        }
      </div>
    </div>
  </div>
}
